import { Box, Typography } from "@mui/material";

const NoDataFound = ({ message = "No data found" }: { message?: string }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      py: 6,
      width: "100%",
    }}
  >
    <figure style={{ width: 180, height: 180, margin: "0 0 16px" }}>
      <img
        src="/static/images/empty.png"
        alt="No data"
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
      />
    </figure>
    <Typography
      sx={{
        fontSize: 16,
        fontWeight: 600,
        color: "#151D30",
        opacity: 0.7,
        textAlign: "center",
      }}
    >
      {message}
    </Typography>
  </Box>
);

export default NoDataFound;
